import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=1fece388&"
import script from "./purchase.vue?vue&type=script&lang=js&"
export * from "./purchase.vue?vue&type=script&lang=js&"
import style0 from "./purchase.vue?vue&type=style&index=0&id=1fece388&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports